import mail from './mail';
import checkEmail from './check_existence';

export default {
  mail
};

export { checkEmail };
